// assets/shipping-estimate.js
(function () {
  const IDS = ['shipping-estimate', 'shipping-estimate-page'];
  let lastRates = {};

  const FALLBACK = {
    zip: '1000001',      // 東京(千代田区) 目安
    country: 'JP',
    province: 'Tokyo'
  };

  // --- 送料APIからレート取得 ---
  async function fetchRates(zip, country, province) {
    const url =
      `/cart/shipping_rates.json?` +
      `shipping_address[zip]=${encodeURIComponent(zip)}` +
      `&shipping_address[country]=${encodeURIComponent(country)}` +
      `&shipping_address[province]=${encodeURIComponent(province)}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch');
    const data = await res.json();
    return data.shipping_rates || [];
  }

  // --- 金額フォーマット ---
  // 💡10円問題対策：Shopifyの送料APIはすでに「円単位」で返す場合がある
  //  → /100 せず、そのまま表示
  function formatMoney(price) {
    let amount = typeof price === 'string' ? parseFloat(price) : price;
    return amount.toLocaleString(undefined, {
      style: 'currency',
      currency: Shopify?.currency?.active || 'JPY'
    });
  }

  // --- DOMに描画 ---
  async function render(id) {
    const el = document.getElementById(id);
    if (!el) return;

    const title  = el.querySelector('.cart__shipping-estimate__title');
    const body   = el.querySelector('.cart__shipping-estimate__body');
    const status = el.querySelector('.cart__shipping-estimate__status');
    if (status) status.textContent = '計算中…';

    let zip      = el.dataset.customerZip      || '';
    let country  = el.dataset.customerCountry  || '';
    let province = el.dataset.customerProvince || '';
    let isFallback = false;

    if (!zip || !country) {
      zip = FALLBACK.zip;
      country = FALLBACK.country;
      province = FALLBACK.province;
      isFallback = true;
    }

    try {
      const rates = await fetchRates(zip, country, province);
      const key   = id + JSON.stringify(rates);
      if (lastRates[id] === key) return; // 前回と同じなら更新しない
      lastRates[id] = key;

      if (!rates.length) {
        body.innerHTML = '<span>該当する送料が見つかりませんでした。</span>';
        return;
      }

      if (title) {
        title.textContent = isFallback
          ? '東京へお届けする場合の送料'
          : 'お届け先に基づく送料';
      }

      body.innerHTML = `
        <ul class="shipping-estimate__list">
          ${rates
            .map(
              r => `
              <li class="shipping-estimate__item">
                <span class="shipping-estimate__name">${r.name}</span>
                <span class="shipping-estimate__price"><strong>${formatMoney(r.price)}</strong></span>
              </li>`
            )
            .join('')}
        </ul>
        <div class="shipping-estimate__note">
          ${
            isFallback
              ? '※ログインすると実際のお届け先に基づいた送料が表示されます。'
              : '※最終金額はチェックアウト画面で確定します。'
          }
        </div>`;
    } catch (e) {
      console.error(e);
      body.innerHTML =
        '<span>送料の取得に失敗しました。時間をおいて再度お試しください。</span>';
    }
  }

  // --- 初期化 ---
  function initAll() {
    IDS.forEach(render);
  }

  // ✅ 1) 初回ロード
  document.addEventListener('DOMContentLoaded', initAll);
  // ✅ 2) DrawerやCartセクションがAjaxで更新された時
  document.addEventListener('shopify:section:load', initAll);
  // ✅ 3) カート内商品の変化を監視（ドロワー・カートページ両方の [data-products] を監視）
  document.querySelectorAll('[data-products]').forEach(function (cartArea) {
    var obs = new MutationObserver(initAll);
    obs.observe(cartArea, { childList: true, subtree: true });
  });
    // ✅ 4) Ajaxカート更新イベントも監視（テーマによって発火するイベント）
  document.addEventListener('cart:updated', initAll);
  document.addEventListener('cart:quantity', initAll);
  document.addEventListener('ajaxCart:updated', initAll);
  document.addEventListener('cart:refresh', initAll);
// ▼送料無料メッセージ（送料見積りと同じ仕組み）▼
(function () {
  // ドロワー・カートページなど複数箇所に対応（同じクラスで複数設置OK）
  function getContainers() { return document.querySelectorAll('.js-free-shipping-message'); }
  if (!getContainers().length) return;

  const FREE_LIMIT = 5000;

  // --- カート小計をAPIから取得（/cart.js）---
  async function fetchCartSubtotal() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();
      // Shopifyのcart.jsは【セント単位】なので /100
      return Math.round(cart.items_subtotal_price / 100);
    } catch (e) {
      console.error('FreeShipping fetch error', e);
      return null;
    }
  }

  // --- メッセージ描画 ---
  async function renderFreeShipping() {
    const subtotal = await fetchCartSubtotal();
    if (subtotal === null) return;

    getContainers().forEach(function (container) {
      const province = container.dataset.customerProvince || '';
      const isHokkaido = /(Hokkaido|JP-01)/i.test(province);
      const isOkinawa  = /(Okinawa|JP-47)/i.test(province);

      let html = '';
      // 北海道・沖縄以外＆小計が5000円未満なら表示
      if (!isHokkaido && !isOkinawa && subtotal < FREE_LIMIT) {
        const diff = FREE_LIMIT - subtotal;
        html = `<div class="free-shipping__alert">
                  あと<strong>${diff.toLocaleString()}</strong>円で送料無料！
                  ${province ? '' : '（一部地域を除く）'}
                </div>`;
      }

      container.innerHTML = html;
      container.style.display = html ? 'block' : 'none';
    });
  }

  // --- 初期化 ---
  function initFreeShipping() {
    renderFreeShipping();
  }

  // ✅ 送料見積もりと同じイベントタイミング
  document.addEventListener('DOMContentLoaded', initFreeShipping);
  document.addEventListener('shopify:section:load', initFreeShipping);
  document.addEventListener('cart:updated', initFreeShipping);
  document.addEventListener('cart:quantity', initFreeShipping);
  document.addEventListener('ajaxCart:updated', initFreeShipping);
  document.addEventListener('cart:refresh', initFreeShipping);

  // ✅ カート商品の変化を監視（ドロワー・カートページ両方の [data-products] を監視）
  document.querySelectorAll('[data-products]').forEach(function (cartArea) {
    var obs = new MutationObserver(initFreeShipping);
    obs.observe(cartArea, { childList: true, subtree: true });
  });
})();
// ▲送料無料メッセージここまで▲
})();
